module.exports = __webpack_public_path__ + "img/trophy.7dc71056.png";